module.exports = __webpack_public_path__ + "static/media/OrangeCheck.9345c9d1.png";